<template>
    <div class="container box app-connexion">
        <div class="p-md m-t-md">
        <form @submit.prevent="checkCreds">
            <b-field :label="$t('connection.email')" class="has-text-left">
                <b-input
                        type="email"
                        v-model="email"
                        required>
                </b-input>
            </b-field>

            <b-field :label="$t('connection.password')" class="has-text-left">
                <b-input
                        type="password"
                        v-model="password"
                        password-reveal
                        required>
                </b-input>
            </b-field>

            <div class="container-fluid">
                <button :class="'button is-primary is-fullwidth ' + isLoading">{{ $t('connection.buttons.connection') }}</button>

                <div class="m-t-md">
                    <a @click="showForgetPassword"><i>{{ $t('connection.forget_password') }}</i></a>
                </div>

            </div>
            <br>
            <div v-if="error" class="notification is-warning animated fadeIn">{{error}}</div>


            <a @click="showRegister" class="button has-background-success has-text-white connexion-switch is-fullwidth">{{ $t('connection.buttons.to_registration') }}</a>



        </form>
    </div>
    </div>
</template>

<script>
    import {mapState, mapActions} from 'vuex'

    export default {
        data () {
            return {
                isLoading: '',
                email: '',
                password: '',
                error: ''
            }
        },
        computed: {
            ...mapState([
                'auth'
            ])
        },
        methods: {
            ...mapActions({
                login: 'auth/login'
            }),
            toggleLoading: function () {
                this.isLoading = (this.isLoading === '') ? 'is-loading' : ''
            },
            showRegister: function () {
                this.$emit('register')
            },
            showForgetPassword: function () {
                this.$emit('forgetPassword')
            },
            checkCreds: function () {
                this.toggleLoading()
                const credentials = {
                    email: this.email,
                    password: this.password
                }

                this.login(credentials).then((result) => {
                    if (this.auth.status === 401) {
                        this.toggleLoading()
                        this.error = this.auth.message
                    }
                    else if (this.auth.account.activated === true) {
                        this.$emit('loggedIn')
                    } else {
                        this.toggleLoading()
                        this.error = this.auth.message
                    }
                }).catch((err) => {
                    this.toggleLoading()
                    this.error = this.$t('auth.unknown')
                })
            }

        }
    }
</script>

<style scope>

    .connexion-switch {
        height: 4rem;
    }

</style>
